import Home from './Home.bundle-pool-edit.vue'

export default {
  Home
}